module.exports = [{"type":"title","text":"2024-08-27"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Spot: Supports OCO order features, providing OCO order placement, OCO order cancellation, querying individual OCO orders, querying open OCO orders, and querying OCO order interfaces."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-08-27.json
// module id = gYbm
// module chunks = 3